module.exports = __webpack_public_path__ + "static/memoirs-and-misinformation-a0b61f6a6b4f5c408ae5c31db1389001.jpg";